import { createSlice } from "@reduxjs/toolkit";

const prevBookingAmountSlice = createSlice({
  name: "prevBookingAmount",
  initialState: {
    prevBookingAmount: 0,
  },
  reducers: {
    setPrevBookingAmountStore: (state, action) => {
      state.prevBookingAmount = action.payload ?? 0;
    },
    clearPrevBookingAmountStore: (state) => {
      state.prevBookingAmount = 0;
    },
  },
});

export const { setPrevBookingAmountStore, clearPrevBookingAmountStore } = prevBookingAmountSlice.actions;
export const selectPrevBookingAmount = (state) => state.prevBookingAmount.prevBookingAmount;
export default prevBookingAmountSlice.reducer;
